import { observer } from 'mobx-react';
import { SymmetricalQuadroViewLayout } from './symmetricalQuadroLayout/SymmetricalQudroViewLayout';
import { useInjection } from 'inversify-react';
import type { QuadroLayoutController } from './QuadroLayout.controller';
import { TYPES } from '@/engine/ioc';
import { QuadroLayoutType } from './QuadroLayoutState.store';
import { AccentedQuadroViewLayout } from './accentedQuadroLayout/AccentedQudroViewLayout';

export const QuadroViewLayout: React.FC = observer(() => {
  const controller = useInjection<QuadroLayoutController>(TYPES.QuadroLayoutController);

  if (controller.activeQuadroLayoutType === QuadroLayoutType.ACCENTED) {
    return <AccentedQuadroViewLayout />;
  }
  if (controller.activeQuadroLayoutType === QuadroLayoutType.SYMMETRICAL) {
    return <SymmetricalQuadroViewLayout />;
  }
});
